var map = {
	"./sel_Beijing.jpg": "2c1b",
	"./sel_Chengdu.jpg": "8f35",
	"./sel_Dalian.jpg": "b743",
	"./sel_Guangzhou.jpg": "0453",
	"./sel_Hong Kong.jpg": "1261",
	"./sel_Shanghai.jpg": "0542",
	"./sel_Shenzhen.jpg": "b764"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1540";